import { createContext, useState } from "react";

export interface SignTypeContextProps {
  selectedOption: string;
  setSelectedOption: (option: string) => void;
  currentInputError: string;
  setCurrentInputError: (error: string) => void;
}

export const SignTypeContext = createContext<SignTypeContextProps>({
  selectedOption: "",
  setSelectedOption: () => { },
  currentInputError: "",
  setCurrentInputError: () => { },
});
export function SignTypeProvider(props: { children: React.ReactNode }) {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [currentInputError, setCurrentInputError] = useState<string>("");

  return (
    <SignTypeContext.Provider
      value={{
        selectedOption,
        setSelectedOption,
        currentInputError,
        setCurrentInputError,
      }}
    >
      {props.children}
    </SignTypeContext.Provider>
  );
}
